// extracted by mini-css-extract-plugin
export default {"tokenTextArea":"styles_tokenTextArea__X6pGE","buttonsWrapper":"styles_buttonsWrapper__Nb3Yw","listTitle":"styles_listTitle__wjfni"};